import eCardRecipient from './eCardRecipient';

export default class eCardMessageDetails {
    constructor(props) {
        const {
            EcardDesignID,
            FromName,
            Message,
            Recipients,
            DonationAmount,
            DonationVisible,
            DateScheduled,
            DateCreated,
            EcardID,
            GtmDonationOption,
            ImageUploadUrl,
            ImageUploadId,
        } = props;

        /**
         * @type {GtmDonationOption}
         * @memberof eCardMessageDetails
         * @description The donation option set only for Gift That Matters Ecards (I miss TypeScript)
         * @example
         * {
         *    Id: string,
         *    Amount: number,
         *    LongDescription: string,
         *    ShortDescription: string,
         *    ShortDescriptionPrefix: string
         * }
         */
        this.GtmDonationOption = GtmDonationOption;

        this.FromName = FromName ?? '';
        this.Message = Message ?? '';
        this.Recipients = Recipients ?? [new eCardRecipient()]; // List of eCardRecipients
        this.DonationAmount = this.GtmDonationOption !== null ? this.GtmDonationOption.Amount : DonationAmount ?? 0;
        this.DonationVisible = DonationVisible ?? true;
        this.EcardDesignID = EcardDesignID;
        this.DateScheduled = DateScheduled ?? null;
        this.DateCreated = DateCreated ?? null;
        this.EcardID = EcardID;
        this.ImageToUpload = null;
        this.ImageUploadUrl = ImageUploadUrl ?? '';
        this.ImageUploadId = ImageUploadId ?? '';
    }
}
